<template>
	<div id="dialogs-container">
		<component
			v-for="[dialogId, dialog] in DialogsService.activeDialogs.value"
			:key="dialogId"
			:is="dialog.component"
			v-bind="dialog.props"
			v-on="dialog.handlers"
			:style="{ zIndex: dialog.zIndex }"
		/>
	</div>
</template>

<script>
import DialogsService from '@/core/services/Dialogs/DialogsService';
export default defineComponent({
	name: 'DialogsContainer',

	data() {
		return {
			DialogsService
		};
	},
});
</script>
